export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          关于我们
        </h2>
        <div className="mt-8 bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            今日看料成立于2017年，是国内领先的内容聚合与导航服务平台。我们致力于为用户提供一站式的优质内容发现体验，
            通过智能推荐与人工精选相结合的方式，每日从海量资源中筛选最具价值的影视、综艺、纪录片、动漫、知识科普等内容。
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            作为今日看料的官方首页导航站点，我们始终保持内容的及时更新与入口的安全稳定。平台已累计服务超过数百万用户，
            凭借丰富的频道覆盖、流畅的浏览体验和严格的内容筛选标准，成为众多用户获取每日精彩内容的首选入口。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-primary-500 font-heading">8年</div>
              <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-accent-500 font-heading">50+</div>
              <div className="text-xs text-foreground-500 mt-1">内容频道</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-secondary-600 font-heading">百万+</div>
              <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}